// The service that call the API to get the data from VEHICLE_API_URL

import { handleAxiosError } from '../../common/application/handleAxiosError';
import useParkstoryApi, { type ApiResponse, Target } from '../../common/data/parkstory/parkstory';
import useUserConvertor from '../domain/user';

import type User from '@/auth/domain/auth';
import { logException } from '@/common/utils/logger';

const useUserApi = () => {

    const { get, put, remove, convertApiResponse } = useParkstoryApi();
    const { apiUserProfileToUserProfile, userToApiUserProfile } = useUserConvertor;

    const apiGetUserProfile = async (): Promise<ApiResponse<User>> => {
        try {
            const response = await get<User>(
                Target.User,
                'user-profile/'
            );
            return convertApiResponse(response, apiUserProfileToUserProfile);
        } catch (error) {
            throw (handleAxiosError(error, 'getUser'));
        }
    };

    const apiDeleteUserAccount = async () : Promise<ApiResponse<any>> => {
        try {
            const response = await remove(
                Target.Vehicle,
                'user'
            );
            return response;
        } catch (error: any) {
            logException(error);
            let errorMessage = error.message;
            if (error.response?.data) {
                if (error.response.data.error?.message) {
                    errorMessage = error.response.data.error.message;
                } else if (error.response.data.message || error.response.data.status) {
                    errorMessage = error.response.data.message;
                }
            }
            throw new Error(`${errorMessage} (${error.response?.status})`); // returns error object with hopefully status and error message
        }
    };
    const apiUpdateUser = async (userProfile: User): Promise<ApiResponse<User>> => {
        try {
            const response = await put<User>(
                Target.User,
                'user-profile/',
                userToApiUserProfile(userProfile)
            );
            return response;
        } catch (error) {
            logException(error);
            throw (handleAxiosError(error, 'updateUser'));
        }
    };

    return {
        apiDeleteUserAccount,
        apiGetUserProfile,
        apiUpdateUser
    };
};

export default useUserApi;
